import { render, staticRenderFns } from "./ComGoodsMemConfig.vue?vue&type=template&id=10d186c5&scoped=true&"
import script from "./ComGoodsMemConfig.vue?vue&type=script&lang=js&"
export * from "./ComGoodsMemConfig.vue?vue&type=script&lang=js&"
import style0 from "./ComGoodsMemConfig.vue?vue&type=style&index=0&id=10d186c5&prod&lang=css&"
import style1 from "./ComGoodsMemConfig.vue?vue&type=style&index=1&id=10d186c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d186c5",
  null
  
)

export default component.exports